import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import * as api from 'api';

import { getActiveCustomer, getUserUpdatePaymentMethodToken } from 'store/auth';

import {
  FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_REQUEST,
  UPDATE_PAYMENT_METHOD_REQUEST,
  fetchPaymentMethodAuthorizationTokenSuccess,
  fetchPaymentMethodAuthorizationTokenFailure,
  updatePaymentMethodSuccess,
  updatePaymentMethodFailure
} from 'store/paymentMethods';

function* fetchPaymentMethodAuthorizationToken(action) {
  try {
    const customer = yield select(getActiveCustomer);

    const updatePaymentMethodToken = yield select(
      getUserUpdatePaymentMethodToken
    );

    const token = yield call(
      api.fetchPaymentMethodAuthorizationToken,
      customer.id,
      updatePaymentMethodToken
    );

    yield put(fetchPaymentMethodAuthorizationTokenSuccess(token));
  } catch (err) {
    yield put(fetchPaymentMethodAuthorizationTokenFailure(err));
  }
}

function* updatePaymentMethod(action) {
  const { authorizationToken, nonce } = action.payload;

  try {
    const customer = yield select(getActiveCustomer);

    const updatePaymentMethodToken = yield select(
      getUserUpdatePaymentMethodToken
    );

    yield call(
      api.updatePaymentMethod,
      customer.id,
      updatePaymentMethodToken,
      authorizationToken,
      nonce
    );

    yield put(updatePaymentMethodSuccess());
  } catch (err) {
    yield put(updatePaymentMethodFailure(err));
  }
}

export default function* paymentMethodsSaga() {
  yield all([
    takeLatest(
      FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_REQUEST,
      fetchPaymentMethodAuthorizationToken
    ),
    takeLatest(UPDATE_PAYMENT_METHOD_REQUEST, updatePaymentMethod)
  ]);
}



// WEBPACK FOOTER //
// ./src/store/paymentMethods/sagas.js